<template lang="pug">
.v-location-picker
	v-field(v-if="geolocationData && geolocationData.cityId"
			:field="computedField"
			v-model="this.geolocationData.cityId"
			@update:model-value="setLocation")
</template>
<script>

export default {
	data() {
		return {
			bxajaxid: null
		};
	},

	computed: {
		geolocationData() {
			return this.$store.state.location;
		},

		computedField() {
			let field;
			let options = [];
			this.geolocationData.items.forEach(item => {
				options.push({
					value: item.cityId,
					text: item.text
				});
			});
			let currentLocation = this.geolocationData.items.find(item => item.cityId === this.geolocationData.cityId);
			if (options.length > 0) {
				field = {
					type: 'select',
					value: currentLocation,
					options
				};
			}
			return field;
		}
	},

	methods: {
		setLocation(cityId) {
			this.$store.dispatch('location/update', {
				cityId: cityId,
				bxajaxid: this.bxajaxid
			});
		}
	}
};
</script>